import { MGameGameConfiguration, mGameContentConfiguration } from './games/m-game/mGameContentConfiguration';
import {
    ZdarGameGameConfiguration,
    zdarEscapeGameContentConfiguration,
} from './games/zdar-escape-game/zdarEscapeGameContentConfiguration';
import {
    ZdarKidsGameGameConfiguration,
    zdarKidsGameContentConfiguration,
} from './games/zdar-kids-game/zdarKidsGameContentConfiguration';

export const ZDAR_ESCAPE_GAME_NAME = 'zdar-escape-game';
export const M_GAME_NAME = 'majky-game';
export const ZDAR_KIDS_GAME_NAME = 'zdar-kids-game';

export const gamesConfiguration = [
    {
        id: 1,
        homeUrl: '/mestska-unikovka-zdar',
        name: ZDAR_ESCAPE_GAME_NAME,
        last: 36,
    },
    {
        id: 2,
        homeUrl: '/m-hra',
        name: M_GAME_NAME,
        last: 34,
    },
    {
        id: 3,
        homeUrl: '/detska-unikovka-zdar',
        name: ZDAR_KIDS_GAME_NAME,
        last: 35,
    },
];

export function getGameCardConfiguration(name: string): GameCardConfiguration | null {
    let configuration = null;
    if (ZDAR_ESCAPE_GAME_NAME === name) {
        configuration = zdarEscapeGameContentConfiguration.cardConfiguration;
    } else if (M_GAME_NAME === name) {
        configuration = mGameContentConfiguration.cardConfiguration;
    } else if (ZDAR_KIDS_GAME_NAME === name) {
        configuration = zdarKidsGameContentConfiguration.cardConfiguration;
    }
    return configuration;
}

type GameType = ZdarGameGameConfiguration | MGameGameConfiguration | ZdarKidsGameGameConfiguration | null;

export function getGameConfiguration(name: string): GameType {
    let configuration = null;
    if (ZDAR_ESCAPE_GAME_NAME === name) {
        configuration = zdarEscapeGameContentConfiguration.gameConfiguration;
    } else if (M_GAME_NAME === name) {
        configuration = mGameContentConfiguration.gameConfiguration;
    } else if (ZDAR_KIDS_GAME_NAME === name) {
        configuration = zdarKidsGameContentConfiguration.gameConfiguration;
    }
    return configuration;
}

export type GameCardConfiguration = {
    title: string;
    subtitle: string;
    background: any;
    gameUrl: string;
    showValidity: boolean;
};
